import { useEffect, useState } from "react";

/**
 * A custom hook to manage the page scroll event for header menu to show or hide in the mobile browser.
 * and returns a string indicating if the scroll is down or up.
 *
 * @returns {boolean} - true if in mobile web view mode, otherwise false.
 */
export const usePageScroll = ({
  initialStart = 256,
}: {
  initialStart: number;
}) => {
  // 1. Initialize with a safe, default value (`undefined`).
  const [scrollDir, setScrollDir] = useState<"up" | "down" | undefined>(
    undefined,
  );

  // 2. This `useEffect` hook handles all browser-side logic. It will NOT run on the server.
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDir = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < initialStart) return;

      setScrollDir(currentScrollY > lastScrollY ? "down" : "up");
      lastScrollY = currentScrollY > 0 ? currentScrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDir);

    return () => {
      window.removeEventListener("scroll", updateScrollDir);
    };
  }, [initialStart]);

  return scrollDir;
};
